'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Guid=require('pulsar-utils/dist-es6/domain/guid');

function _areEqualDates(date1,date2){
return _.exists(date1)&&_.exists(date2)&&date1.getTime()===date2.getTime();
}let

DateTimeDirectiveController=function(){_createClass(DateTimeDirectiveController,null,[{key:'$inject',get:function()
{
return[];
}}]);

function DateTimeDirectiveController(){_classCallCheck(this,DateTimeDirectiveController);
this._dateId=Guid.create().toString();
this._timeId=Guid.create().toString();
}DateTimeDirectiveController.prototype.
























updateValue=function updateValue(){
if(!_.exists(this._date)||!_.exists(this._time)){
this._value=null;
return;
}

let newValue=new Date(
this._date.getFullYear(),
this._date.getMonth(),
this._date.getDate(),
this._time.getHours(),
this._time.getMinutes(),
this._time.getSeconds());

if(!_areEqualDates(newValue,this._value)){
this._value=newValue;
}
};_createClass(DateTimeDirectiveController,[{key:'dateId',get:function(){return this._dateId}},{key:'timeId',get:function(){return this._timeId}},{key:'value',get:function(){return this._value},set:function(newValue){if(_.exists(newValue)){this.date=new Date(newValue.getFullYear(),newValue.getMonth(),newValue.getDate());this.time=new Date(newValue)}else{this.date=null;this.time=null}this.updateValue()}},{key:'date',get:function()

{
return this._date;
},set:function(

newDate){
if(_areEqualDates(newDate,this._date)){
return;
}
this._date=newDate;
this.updateValue();
}},{key:'time',get:function()

{
return this._time;
},set:function(

newTime){
if(_areEqualDates(newTime,this._time)){
return;
}
this._time=newTime;
this.updateValue();
}},{key:'showDateError',get:function()

{
return this.form[this._dateId].$touched&&!_.exists(this.date);
}},{key:'showTimeError',get:function()

{
return this.form[this._timeId].$touched&&!_.exists(this.time);
}}]);return DateTimeDirectiveController}();let


DateTimeDirective=function(_BaseControllerBacked){_inherits(DateTimeDirective,_BaseControllerBacked);function DateTimeDirective(){_classCallCheck(this,DateTimeDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DateTimeDirective,[{key:'objectBindings',get:function()
{
return['value','form'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/dateTimeDirective/dateTimeTemplate';
}},{key:'controller',get:function()

{
return DateTimeDirectiveController;
}}]);return DateTimeDirective}(BaseControllerBackedDirective);


module.exports=DateTimeDirective;
//# sourceMappingURL=dateTimeDirective.js.map
